import React, { useEffect, useState } from 'react';

import { subjectsApi } from 'api/subjects-api';
import { Option, OptionFormType } from 'shared/types';

interface Props {
  onSetOption: React.Dispatch<React.SetStateAction<Option | null>>;
  onAddEdit: () => void;
  onRemove: () => void;
}

export const SubjectsOptions = ({ onAddEdit, onRemove, onSetOption }: Props) => {
  const [subjects, setSubjects] = useState<Option[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    const updateSubjects = (subjects: Option[]) => setSubjects(subjects);
    const unsubscribe = subjectsApi.subscribeToChanges(updateSubjects);

    setIsLoading(false);

    return () => {
      unsubscribe();
    };
  }, []);

  const chooseSubject = (subject: Option | null, formType: OptionFormType) => {
    onSetOption(subject);

    if (formType === OptionFormType.remove) {
      onRemove();
    } else {
      onAddEdit();
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2>Subjects</h2>

        <button onClick={() => chooseSubject(null, OptionFormType.add)}>Add new subject</button>
      </div>

      <ul>
        {subjects?.map(subject => (
          <li key={subject.id} className="flex items-center justify-between">
            <p>{subject.ruName}</p>
            <p>{subject.name}</p>

            <div className="flex items-center justify-between gap-2">
              <button onClick={() => chooseSubject(subject, OptionFormType.edit)}>Edit</button>
              <button onClick={() => chooseSubject(subject, OptionFormType.remove)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
